import React from "react";

const SearchIcon = ({ isActive }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.875 19L15.5105 15.6295L18.875 19ZM17.375 11.125C17.375 12.8158 16.7034 14.4373 15.5078 15.6328C14.3123 16.8284 12.6908 17.5 11 17.5C9.30924 17.5 7.68774 16.8284 6.49219 15.6328C5.29665 14.4373 4.625 12.8158 4.625 11.125C4.625 9.43424 5.29665 7.81274 6.49219 6.61719C7.68774 5.42165 9.30924 4.75 11 4.75C12.6908 4.75 14.3123 5.42165 15.5078 6.61719C16.7034 7.81274 17.375 9.43424 17.375 11.125V11.125Z"
      stroke={isActive ? "#1A1B1B" : "#c7c7c7"}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default SearchIcon;
